import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Discrete level selector — a grid of labeled buttons where one is selected.
 *
 * Value is **index-based**: the selected button's array index is the value.
 * For id-based selection, use PresetGrid instead.
 *
 * @param {Object}   props
 * @param {Array}    props.levels   — Array of level objects (must have a label key)
 * @param {number}   props.value    — Selected index
 * @param {Function} props.onChange  — (index: number) => void
 * @param {string}   [props.labelKey] — Key to read label from (default: "label")
 * @param {number}   [props.cols]    — Grid columns (default: 4)
 */
export function LevelPicker({ levels, value, onChange, labelKey = 'label', cols = 4 }) {
  return (
    <div className="grid gap-1" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
      {levels.map((lvl, i) => (
        <button
          key={i}
          onClick={() => onChange(i)}
          className={cn(
            'py-1 rounded-lg border text-[10px] font-medium transition-all',
            value === i
              ? 'border-white/25 bg-white/10 text-white/90'
              : 'border-white/8 bg-white/[0.02] text-white/45 hover:bg-white/[0.06] hover:text-white/65'
          )}
        >
          {lvl[labelKey]}
        </button>
      ))}
    </div>
  );
}
